// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__W2EGI","footerInfo":"footer_footerInfo__hqoVF","socials":"footer_socials__WycYQ","social":"footer_social__Gb7S5","miniMenu":"footer_miniMenu__hfY+W"};